import React from 'react'

// Components
import { Text } from '../../../../../../components'

// Hooks
import { useListingDisplay } from '../../../../../../hooks/listing'

// Helpers
import { formatAbbrCurrency } from '../../../../../../helpers'

const DownPaymentHint = () => {
  const {
    currentAddress,
    estimatedDownPaymentFromEquity,
    usingDefaultDownPayment,
  } = useListingDisplay()

  if (usingDefaultDownPayment) {
    return null
  }

  return (
    <>
      <Text element='span'>If you sold </Text>
      <Text element='span' color='white' weight='bold'>
        {currentAddress || 'your current home'}
      </Text>
      <Text element='span'> today, you could have around </Text>
      <Text element='span' color='green' weight='bold'>
        {formatAbbrCurrency(estimatedDownPaymentFromEquity)}
      </Text>
      <Text element='span'> in your pocket after selling fees.</Text>
    </>
  )
}

export default DownPaymentHint
